export type ActionAnalyticDataType = {
  user_action: string;
  action_count: number;
};

export type AnalyticActionResponseListType = {
  actions: ActionAnalyticDataType[];
};

export type MonthlyAnalyticDataType = {
  month: string;
  action_counts: {
    action: string;
    action_count: number;
  }[];
};

export type DataSetType = {
  [action: string]: number[];
};

export type UserMapDataType = Record<string, string[]>;

export enum DurationEnum {
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
}

export enum ActionType {
  all = 'all',
  perform_port_bounce_action = 'perform_port_bounce_action',
  perform_port_flip_action = 'perform_port_flip_action',
  perform_limited_port_flip_action = 'perform_limited_port_flip_action',
  perform_limited_port_bounce_action = 'perform_limited_port_bounce_action',
  dhcp_reservation_create = 'dhcp_reservation_create',
  dhcp_reservation_update = 'dhcp_reservation_update',
  dhcp_reservation_delete = 'dhcp_reservation_delete',
  dhcp_reservation_resolve_conflict = 'dhcp_reservation_resolve_conflict',
}

export enum RoleType {
  all = 'all',
  ncc_user = 'user',
  ncc_it = 'ncc_it',
  ncc_engineer = 'engineer',
  ncc_admin = 'admin',
}

export enum BreakdownTab {
  role = 'role',
  user = 'user',
}

export type ActionCount = {
  action: string;
  action_count: number;
};

export type RoleActionBreakdown = {
  role: string;
  action_counts: ActionCount[];
};

export type RoleActionPeriodBreakdown = {
  period: string;
  roles: RoleActionBreakdown[];
};

export type RoleActionBreakdownResponseList = {
  periods: RoleActionPeriodBreakdown[];
};

export type UserActionBreakdown = {
  user_email: string;
  action_counts: ActionCount[];
};

export type UserActionPeriodBreakdown = {
  period: string;
  users: UserActionBreakdown[];
};

export type UserActionBreakdownResponseList = {
  periods: UserActionPeriodBreakdown[];
};

export const ALL = 'all';

export type BreakdownFilterParams = {
  duration: DurationEnum;
  actions: ActionType[];
  role: RoleType;
  users: string[];
  tab: BreakdownTab;
  topN: number;
};
